import {ServiceTemplate} from "../../domain/Service";

export const TEMPLATES_MAP = new Map<string, ServiceTemplate>();
